import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLike, curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {BinaryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/binary-math-operator/geometry-binary-math-operator-node"
import {
    GeometryBinaryMathOperatorNode,
    binaryMathOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/binary-math-operator/geometry-binary-math-operator-node"

export type CurveGeometryBinaryMathOperatorParameters = BinaryMathOperatorParameters<CurveGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryBinaryMathOperatorParameters> = {
    nodeClass: "CurveGeometryBinaryMathOperator",
    validation: {
        parameters: binaryMathOperatorParametersSchema(curveGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryBinaryMathOperator
    extends GeometryBinaryMathOperatorNode<1, CurveGeometryAttributeLikeNode>
    implements CurveGeometryAttributeLikeNode
{
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
